module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Coupon.c7bb9e99.svg";